/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { GeodesistResponse } from '../types/Geodesist';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type GeodesistsRetrieveRequest = {} | null | undefined;
export type GeodesistsRetrieveResponse = GeodesistResponse;

export type GeodesistsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this geodesist.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/geodesists/{id}/
 *
 * ```yaml
 * operationId: geodesists_retrieve
 * tags:
 *   - geodesists
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Geodesist'
 *     description: ''
 * ```
 */
export const geodesistsRetrieveOperation = ({ id, ...rest }: GeodesistsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/geodesists/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/geodesists/{id}/' };
  };

/**
 * GET /dmx-server/geodesists/{id}/
 *
 * ```yaml
 * operationId: geodesists_retrieve
 * tags:
 *   - geodesists
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Geodesist'
 *     description: ''
 * ```
 */
export const geodesistsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: GeodesistsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<GeodesistResponse>> => {
  const operation = geodesistsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/geodesists/{id}/
 */
export const useGeodesistsRetrieveResource = (
  query: GeodesistsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<GeodesistsRetrieveResponse> => {
  return useResource<GeodesistsRetrieveResponse>({
    path: query === null ? null : geodesistsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
